import {forwardRef} from 'react';

import {SizeTokenValue} from 'common';

import {SVG} from './SVG';

import type {IconComponent} from '../types';

const largeIcon = (
  <path d="M3.34502 7.32001V16.665H20.685V7.32001H3.34502ZM18.675 14.655H5.34002V9.33001H18.675V14.655ZM17.01 10.995H7.00502V12.99H17.01V10.995Z" />
);

const smallIcon = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M4.89957 3.10054C4.67893 2.8799 4.32119 2.8799 4.10054 3.10054L2.10054 5.10054C1.8799 5.32119 1.8799 5.67893 2.10054 5.89957C2.32119 6.12022 2.67893 6.12022 2.89957 5.89957L3.93506 4.86409V10.1359L2.89957 9.10043C2.67893 8.87978 2.32119 8.87978 2.10054 9.10043C1.8799 9.32107 1.8799 9.67881 2.10054 9.89946L4.10054 11.8995C4.32119 12.1201 4.67893 12.1201 4.89957 11.8995L6.89957 9.89946C7.12022 9.67881 7.12022 9.32107 6.89957 9.10043C6.67893 8.87978 6.32119 8.87978 6.10054 9.10043L5.06506 10.1359V4.86409L6.10054 5.89957C6.32119 6.12022 6.67893 6.12022 6.89957 5.89957C7.12022 5.67893 7.12022 5.32119 6.89957 5.10054L4.89957 3.10054ZM8.50006 4.93506C8.18802 4.93506 7.93506 5.18802 7.93506 5.50006C7.93506 5.8121 8.18802 6.06506 8.50006 6.06506H13.5001C13.8121 6.06506 14.0651 5.8121 14.0651 5.50006C14.0651 5.18802 13.8121 4.93506 13.5001 4.93506H8.50006ZM8.50006 8.93506C8.18802 8.93506 7.93506 9.18802 7.93506 9.50006C7.93506 9.8121 8.18802 10.0651 8.50006 10.0651H13.5001C13.8121 10.0651 14.0651 9.8121 14.0651 9.50006C14.0651 9.18802 13.8121 8.93506 13.5001 8.93506H8.50006ZM7.93506 7.50006C7.93506 7.18802 8.18802 6.93506 8.50006 6.93506H13.5001C13.8121 6.93506 14.0651 7.18802 14.0651 7.50006C14.0651 7.8121 13.8121 8.06506 13.5001 8.06506H8.50006C8.18802 8.06506 7.93506 7.8121 7.93506 7.50006Z"
  />
);

export const CutTextSIcon: IconComponent = forwardRef((props, ref) => {
  const {size} = props;

  return (
    <SVG ref={ref} name="CutTextS" {...props}>
      {!size || size === SizeTokenValue.Large || size === SizeTokenValue.Medium ? largeIcon : smallIcon}
    </SVG>
  );
});
